import _sfc_main from './src/teleport.vue2.mjs';
export { teleportProps } from './src/teleport.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElTeleport = withInstall(_sfc_main);

export { ElTeleport, ElTeleport as default };
//# sourceMappingURL=index.mjs.map
